import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { Col, Form, Modal, Row, Spin, Tabs } from 'antd'
import moment from 'moment'

import { integrationsService } from './../../redux/services'
import { UIDrawerForm } from './../../components'
import ColumnTable from './table'
import EventColumnTable from './tableEvents'

class Show extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    external: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
      uuid: 0,
      item: {},
      general_key: null,

      // dados das tabelas (somente leitura)
      eventData: [],
      columnDataIsLoading: false,
      eventColumnData: [],
      eventDataIsLoading: false,
    }
  }

  handleTabClick = () => { }

  onOpen = (uuid, key) => {
    this.setState({
      isLoading: true,
      uuid,
      item: {},
      general_key: key,
      columnDataIsLoading: true,
      eventDataIsLoading: true,
    })

    integrationsService
      .show({ uuid })
      .then((response) => {
        const item = response?.data?.data ?? {}

        // suporta novo contrato (eventos.{columnData,eventColumnData}) e legados (na raiz)
        const ev = item?.eventos ?? {}

        const eventData =
          Array.isArray(ev?.eventData) ? ev.eventData : []

        const eventColumnData =
          Array.isArray(ev?.eventColumnData) ? ev.eventColumnData
            : Array.isArray(item?.columnData) ? item.columnData
              : []

        this.setState({
          isLoading: false,
          item,
          eventData,
          columnDataIsLoading: false,
          eventColumnData,
          eventDataIsLoading: false,
        })
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
          columnDataIsLoading: false,
          eventDataIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(err),
          onOk: () => this.onClose(),
        })
      })
  }

  resetFields = () => {
    this.setState({ item: {} })
  }

  onClose = () => {
    this.resetFields()
    this.props.onClose()
  }

  formatDMY = (d) => (d ? moment(d).format('DD/MM/YYYY') : '-')
  formatCalendar = (d) => (d ? moment(d).calendar() : '-')

  render() {
    const { visible } = this.props
    const {
      isLoading,
      item,
      eventData,
      columnDataIsLoading,
      eventColumnData,
      eventDataIsLoading,
    } = this.state

    return (
      <UIDrawerForm
        visible={visible}
        width={800}
        onClose={this.onClose}
        isLoading={isLoading}
        showBtnSave={false}
        title={`Visualizar Integração`}
      >
        <Form layout="vertical" disabled>
          <Tabs onTabClick={this.handleTabClick}>
            <Tabs.TabPane forceRender tab="Info. Gerais" key="general">
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item label="Empresa(s)">
                    {item.empresas?.length > 0
                      ? item.empresas.map((empresa, index) => (
                        <span key={empresa.id}>
                          {empresa.nome}
                          {index < item.empresas.length - 1 ? <br /> : ''}
                        </span>
                      ))
                      : 'Todas'}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item label="Departamento(s)">
                    {item.departamentos?.length > 0
                      ? item.departamentos.map((departamento, index) => (
                        <span key={departamento.id}>
                          {departamento.nome}
                          {index < item.departamentos.length - 1 ? <br /> : ''}
                        </span>
                      ))
                      : 'Todos'}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item label="Funcionário(s)">
                    {item.funcionarios?.length > 0
                      ? item.funcionarios.map((func, index) => (
                        <span key={func.id}>
                          {func.nome}
                          {index < item.funcionarios.length - 1 ? <br /> : ''}
                        </span>
                      ))
                      : 'Todos'}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item label="Layout">
                    {item.layout ?? '-'}
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  {/* Tabela de COLUNAS (formatação/layout) — somente leitura */}
                  <ColumnTable
                    notFoundContent={
                      columnDataIsLoading ? (
                        <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                      ) : null
                    }
                    eventData={eventData}
                    readOnly
                  />
                </Col>

                <Col xs={24}>
                  <Form.Item label="Descrição">{item.descricao ?? '-'}</Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Criação">
                    {this.formatCalendar(item.created_at)}
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item label="Última atualização">
                    {this.formatCalendar(item.updated_at)}
                  </Form.Item>
                </Col>
              </Row>
            </Tabs.TabPane>

            <Tabs.TabPane forceRender tab="Eventos" key="eventos">
              <Row gutter={16}>
                <Col xs={24}>
                  {/* Tabela de EVENTOS (evento/código) — somente leitura */}
                  <EventColumnTable
                    notFoundContent={
                      eventDataIsLoading ? (
                        <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} />
                      ) : null
                    }
                    eventData={eventColumnData}
                    readOnly
                  />
                </Col>
              </Row>
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </UIDrawerForm>
    )
  }
}

export default Show
